import { Component, Inject, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DataComparison } from '../../models/DataComparison';
import { MatTableModule } from '@angular/material/table';
import { DeviceRg } from '../../models/DeviceRg';
import { DeviceBit } from '../../models/DeviceBit';
import { AccueilService } from '../accueil.service';
import { GenericSearchService } from '../../generic-components/generic-search/generic-search.service';
import { PageInformations } from '../../generic-components/generic-table/class/PageInformations';
import { MatPaginator } from '@angular/material/paginator';
import { CommonModule } from '@angular/common';
import {
  MatSlideToggle,
  MatSlideToggleChange,
  MatSlideToggleModule,
} from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { DeviceDetailsComponent } from './device-details/device-details.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Incident } from '../../models/Incident';
import { IncidentService } from '../../incident/incident.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-data-comparison-details',
  imports: [
    MatCardModule,
    MatTableModule,
    MatPaginator,
    CommonModule,
    MatSlideToggleModule,
    MatIconModule,
    MatTooltipModule,
    MatExpansionModule,
    FormsModule
  ],
  templateUrl: './data-comparison-details.component.html',
  styleUrl: './data-comparison-details.component.css',
})
export class DataComparisonDetailsComponent implements OnInit {
  dataComparison: DataComparison;

  allDevicesRg: DeviceRg[] = [];

  allDevicesBit: DeviceBit[] = [];


  devicesRg: DeviceRg[] = [];

  devicesBit: DeviceBit[] = [];

  displayedRgColumns: string[] = ['nomAgent', 'os', 'type', 'affranchir'];
  displayedBitColumns: string[] = [
    'nom',
    'os',
    'type',
    'ATS',
    'MDR',
    'EDR',
    'CRY',
    'PATCH',
    'affranchir'
  ];

  pageRgInformations: PageInformations = new PageInformations();

  pageBitInformations: PageInformations = new PageInformations();

  rgFilters = {
    errors: false,
    serveurs: false,
    postes: false,
    equipements: false
  };

  bitFilters = {
    errors: false,
    serveurs: false,
    postes: false,
    equipements: false
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private searcheService: GenericSearchService,
    private incidentService: IncidentService,
    private dialog: MatDialog
  ) {
    this.dataComparison = data;
  }
  ngOnInit(): void {
    this.loadDeviceRg();
    this.loadDeviceBit();
  }

  onPageRgEvent(event: any) {
    this.pageRgInformations.pageIndex = event.pageIndex;
    this.pageRgInformations.pageSize = event.pageSize;
    this.loadDeviceRg();
  }

  onPageBitEvent(event: any) {
    this.pageBitInformations.pageIndex = event.pageIndex;
    this.pageBitInformations.pageSize = event.pageSize;
    this.loadDeviceBit();
  }

  loadDeviceRg(query?: string) {
    if (query == undefined) {
      query =
        'client.codeDivalto=' +
        this.dataComparison.correspondance?.codeDivalto +
        ';syncro.idSyncro=' +
        this.dataComparison.syncro?.idSyncro;
    } else {
      query =  'client.codeDivalto=' +
        this.dataComparison.correspondance?.codeDivalto +
        ';syncro.idSyncro=' +
        this.dataComparison.syncro?.idSyncro + query;
    }
    this.searcheService
      .searchWithEndpointPersonnalized(
        'device/rg',
        query,
        this.pageRgInformations.pageIndex,
        this.pageRgInformations.pageSize,
        'type.libelle=desc,nomAgent=asc'
      )
      .subscribe((result) => {
        this.devicesRg = result.content;
        this.pageRgInformations = this.searcheService.updatePageInformations(
          this.pageRgInformations,
          result
        );
      });
  }

  loadDeviceBit(query?: string) {
    if (query == undefined) {
      query =
        'client.codeDivalto=' +
        this.dataComparison.correspondance?.codeDivalto +
        ';syncro.idSyncro=' +
        this.dataComparison.syncro?.idSyncro;
    }else {
      query =  'client.codeDivalto=' +
        this.dataComparison.correspondance?.codeDivalto +
        ';syncro.idSyncro=' +
        this.dataComparison.syncro?.idSyncro + query;
    }
    this.searcheService
      .searchWithEndpointPersonnalized(
        'device/bit',
        query,
        this.pageBitInformations.pageIndex,
        this.pageBitInformations.pageSize,
        'type.libelle=desc,nom=asc'
      )
      .subscribe((result) => {
        this.devicesBit = result.content;

        this.pageBitInformations = this.searcheService.updatePageInformations(
          this.pageBitInformations,
          result
        );
      });
  }

  isMatchingRow(device: any, source: 'rg' | 'bit'): string {
    const incidentAffranchi = device.haveIncidentAffranchi ?? false;
    if (source === 'rg') {
      if (device.haveProblemCorrespondanceBit == true && incidentAffranchi == false) {
        return 'highlighted-red';
      } else {
        return 'highlighted'
      }
    } else {
      if (device.haveProblemCorrespondanceRg == true && incidentAffranchi == false) {
        return 'highlighted-red';
      } else {
        return 'highlighted'
      }
    }
  }


  applyFilters(
    filters: { errors: boolean; serveurs: boolean; postes: boolean; equipements: boolean },
    loadFn: (query: string) => void,
    errorField: string
  ) {
    if (filters.errors) {
      filters.serveurs = false;
      filters.postes = false;
      filters.equipements = false;
    }
  
    const orFilters: string[] = [];
  
    if (filters.serveurs) orFilters.push("type.code==SERV");
    if (filters.postes) orFilters.push("type.code==POS");
    if (filters.equipements) orFilters.push("type.code==EQUI");
  
    let activeFilters = '';
  
    if (filters.errors) {
      activeFilters += `;${errorField}==true`;
    }
  
    if (orFilters.length > 0) {
      activeFilters += `;(${orFilters.join(',')})`;
    }
  
    loadFn(activeFilters);
  }
  
  
  onRgFiltersChange() {
    this.applyFilters(this.rgFilters, q => this.loadDeviceRg(q), 'haveProblemCorrespondanceBit');
  }
  
  onBitFiltersChange() {
    this.applyFilters(this.bitFilters, q => this.loadDeviceBit(q), 'haveProblemCorrespondanceRg');
  }


  onRowRgClicked(row: any){
    this.dialog.open(DeviceDetailsComponent, {
      data:{
        rg: row
      }
    })
  }

  onRowBitClicked(row: any){
    this.dialog.open(DeviceDetailsComponent, {
      data:{
        bit: row
      }
    })
  }

  shouldShowAffranchir(element: any, type: 'rg' | 'bit'): boolean {
    const incidentAffranchi = element.haveIncidentAffranchi ?? false;
  
    if (type === 'rg') {
      return element.haveProblemCorrespondanceBit && incidentAffranchi === false;
    }
  
    if (type === 'bit') {
      return element.haveProblemCorrespondanceRg && incidentAffranchi === false;
    }
  
    return false;
  }
  
  
  // Action à effectuer lorsque l'utilisateur clique sur Affranchir
  affranchirDevice(element: any, type: 'rg' | 'bit' ) {
    let query = "statutIncident.codeStatutIncident==EC;";

    if(type === 'rg'){

      query += `comparison.correspondance.libelleRg=="${element.client.libelleRg}";deviceRg.idAgent==${element.idAgent};deviceRg.nom=="${element.nom}"`;
    }

    if(type === 'bit'){

      query += `comparison.correspondance.libelleBit=="${element.client.libelleBit}";deviceBit.idBit==${element.idBit};deviceBit.nom=="${element.nom}"`;
    }

    this.searcheService
      .searchWithEndpointPersonnalized('incident/search', query,0,1,'idIncident=desc')
      .subscribe((result:any) => {
        let incident: Incident = result.content[0];
        this.incidentService.createAffranchiFromDashboard(incident,this.dataComparison.idDataComparison).subscribe((res:any) => {
          
          element.haveIncidentAffranchi = true;
          if(type === 'rg'){
            element.haveProblemCorrespondanceBit = false;
            this.devicesRg = [...this.devicesRg];
          }

          if(type === 'bit'){
            element.haveProblemCorrespondanceBit = false;
            this.devicesBit = [...this.devicesBit];
          }
          
        })
        
      });
  }

}
